import React from "react"
import styled from "styled-components"
import FBIcon from "../../images/icons/facebook.svg"
import TWIcon from "../../images/icons/twitter.svg"
import DCIcon from "../../images/icons/discord.svg"
import theme from "../../theme"

const StyledSocials = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 150px;
  width: 100px;
  position: absolute;
  top: 50%;
  z-index: 50;
  right: 5rem;
  @media only screen and (max-width: ${theme.breakpoints.md}) {
    right: 0rem;
  }
`

const ShareHeading = styled.span`
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 600;
`

const Share = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  align-items: center;
`

const Join = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Icon = styled.img`
  height: 32px;
  width: 32px;
  object-fit: contain;
  margin: 0.5rem 0;
  transition: 0.27s ease;
  &:hover,
  &:focus {
    transform: scale(1.1);
  }
`

const currentURL = "https://arkweb.netlify.app"
const twitterShareURL = `https://twitter.com/intent/tweet?url=${currentURL}`
const facebookShareURL = `https://www.facebook.com/sharer.php?u=${currentURL}`

const Socials = () => {
  return (
    <StyledSocials>
      <Share>
        <ShareHeading>Share</ShareHeading>
        <ul>
          <li>
            <a href={twitterShareURL} target="_blank" rel="noreferrer">
              <Icon src={TWIcon} alt="Twitter Icon" />
            </a>
          </li>
          <li>
            <a href={facebookShareURL} target="_blank" rel="noreferrer">
              <Icon src={FBIcon} alt="Facebook Icon" />
            </a>
          </li>
        </ul>
      </Share>
      <Join>
        <ShareHeading>Join</ShareHeading>
        <ul>
          <li>
            <a href="https://discord.gg/f5B9nbG" target="_blank" rel="noreferrer">
              <Icon src={DCIcon} alt="Discord Icon" />
            </a>
          </li>
        </ul>
      </Join>
    </StyledSocials>
  )
}

export default Socials
